// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"bbde9a6f7776575d775f","655":"176b00bbf563a9acccb1"}[chunkId] + ".js";
};